export const ROLE_NAME = {
      admin: 'user_management.option_admin',
      approver: 'user_management.option_approve',
      user: 'user_management.option_user',
}